<template>
    <div>
        <van-nav-bar
            title="招标订阅"
            left-text="返回"
            left-arrow
            @click-left="$router.back()"
        />
        <div class="bg-light padding">
            <div class="padding-left-right f14 dark-2">
                选择行业（已选 <b class="brand">{{formData.hangye_ids ? formData.hangye_ids.length : 0}}</b> 个）
            </div>
            <van-row gutter="10" class="cl padding">
                <van-col :span="6" v-for="(item,index) in hyList" class="margin-bottom">
                    <span class="tag-item block" :class="formData.hangye_ids.indexOf(item.id) >= 0 ? 'on' : ''" @click="chooseHy(item)">{{item.name}}</span>
                </van-col>
            </van-row>
        </div>
        <div class="bg-light padding margin-top">
            <div class="padding-left-right f14 dark-2">
                选择地区（已选 <b class="brand">{{formData.province_codes ? formData.province_codes.length : 0}}</b> 个）
            </div>
            <van-row gutter="10" class="cl padding">
                <van-col :span="6" v-for="(item,index) in areaList" class="margin-bottom">
                    <span class="tag-item block" :class="formData.province_codes.indexOf(item.code) >= 0 ? 'on' : ''" @click="chooseArea(item)">{{item.name}}</span>
                </van-col>
            </van-row>
        </div>
<!--        <van-cell center title="开启推送" class="margin-top">-->
<!--            <template #right-icon>-->
<!--                <van-switch v-model="checked" size="24" />-->
<!--            </template>-->
<!--        </van-cell>-->
        <van-button type="info" square block @click="submit">保存订阅</van-button>
    </div>
</template>

<script>
export default {
    name: "rss",
    data(){
        return{
            areaList:[],
            hyList:[],

            // chooseAreaList:[],
            // chooseHyList:[],

            checked:true,

            formData:{
                hangye_ids:[],
                province_codes:[]
            }
        }
    },
    created() {
        // this.chooseAreaList = this.$user.getArea() ? this.$user.getArea() : [];
        // this.chooseHyList = this.$user.getHy() ? this.$user.getHy() : [];
        this.getArea();
        this.getHy();
    },
    mounted() {
        // this.getArea();
        // this.getHy();

        this.getMyInterest();
    },
    methods:{
        getArea(){
            let _this = this;
            this.$http.post({
                url:'Area/listAll',
                data:{pid:'1'},
                success(res){
                    _this.areaList = res;
                }
            })
        },
        getHy(){
            let _this = this;
            this.$http.post({
                url:'Type/listAll',
                data:{akey:'industry',orderBy:'sort',sortBy:'asc'},
                success(res){
                    _this.hyList = res;
                }
            })
        },
        chooseArea(item){
            let _i = this.formData.province_codes.indexOf(item.code);

            if(_i >= 0){
                this.formData.province_codes.splice(_i,1);
            }else{
                this.formData.province_codes.push(item.code);
            }
        },
        chooseHy(item){
            let _i = this.formData.hangye_ids.indexOf(item.id);

            if(_i >= 0){
                this.formData.hangye_ids.splice(_i,1);
            }else{
                this.formData.hangye_ids.push(item.id);
            }
            // this.formData.hangye_ids = [item.id];
        },
        submit(){
            let _this = this;
            this.$http.post({
                url:'AuthUser/editInterest',
                data:this.formData,
                success(res){
                    // console.log(res);
                    if(res === 'ok'){
                        _this.$toast.success({message:'保存成功',duration:0});
                        setTimeout(()=>{
                            _this.$toast.clear();
                            _this.$router.replace({path:'/'});
                        },3000)
                    }
                    // _this.hyList = res;
                }
            })
        },
        getMyInterest(){
            let _this = this;
            this.$http.post({
                url:'AuthUser/getInterest',
                data:null,
                success(res){
                    _this.formData = res;
                    // _this.hyList = res;
                }
            })
        }
    }
}
</script>
